import React from 'react';

const Statistics: React.FC = () => {
  return (
    <div>
      <h1>Statistics</h1>
      <p>This is the Statistics component.</p>
    </div>
  );
};

export default Statistics;
